import React from 'react';
import PropTypes from 'prop-types';

import Item from '@stubhub/react-event-item';
import {getSellEventUrl} from '@stubhub/sell-url-helper';

import './index.scss';

/**
 * A list of event-item, this is specific to discovery's EventList as their List component is stateless
 */
const SellEventList = (props) => {
  const {
    isMultipleEventToggleSelected,
    onEventItemClick,
    events,
    selectedEvents,
    onEventItemCheckboxClick,
    isSell,
    ...eventItemOptions
  } = props;

  return (
    <div>
      {events &&
        events.map((event, index) => {
          const sellFlowUrl = getSellEventUrl(event.id);

          return (
            <Item
              event={event}
              key={event.id}
              isSell={isSell}
              sellFlowUrl={sellFlowUrl}
              isMultipleEventToggleSelected={isMultipleEventToggleSelected}
              onEventItemCheckboxClick={onEventItemCheckboxClick}
              isMultiCheckboxChecked={selectedEvents[event.id]}
              onClick={() => onEventItemClick && onEventItemClick(event, index)}
              {...eventItemOptions}
            />
          );
        })}
    </div>
  );
};

SellEventList.propTypes = {
  events: PropTypes.array,
  onEventItemClick: PropTypes.func,
  eventItemOptions: PropTypes.object,
  isSell: PropTypes.bool,
  getSellEventUrl: PropTypes.func,
};

export default SellEventList;
